import React from 'react';
import { BadgeCheck, BrainCircuit, Sparkles, TimerReset } from 'lucide-react';

const highlights = [
  {
    icon: BadgeCheck,
    label: '01',
    title: 'Zero-risk pricing model',
    body: 'CPA/CPS only -- pay per verified sale',
  },
  {
    icon: BrainCircuit,
    label: '02',
    title: 'AI buyer intent modeling',
    body: '100+ variables scored in real-time',
  },
  {
    icon: Sparkles,
    label: '03',
    title: 'Dynamic creative optimization',
    body: 'Limitless ad variations, auto-tested',
  },
  {
    icon: TimerReset,
    label: '04',
    title: 'Live in 48 hours',
    body: 'One tag. Fully managed. No engineers needed.',
  },
];

export default function HighlightsSection() {
  return (
    <section className="highlights-section" data-testid="highlights-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360 relative z-10">
        <div className="highlights-title"> 
          <div className="highlights-kicker">
            <span />
            Our Highlights
          </div>
          <div className='grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start'>
              <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            Retargeting built for <span className="accent">measurable revenue</span>
          </h2>
            <div className="lg:col-span-5">
              <p className="reveal-on-scroll sec-subhead">
              A unified growth engine combining performance infrastructure, AI-powered decisioning, and fully managed execution—built to maximise conversions, scale efficiently, and drive measurable revenue.
            </p>
            </div>
          </div>
          
        </div>

        <div className="highlights-grid mt-4 md:mt-6 xl:mt-10">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <article
                key={item.title}
                className="highlight-card reveal-on-scroll"
                style={{ transitionDelay: `${index * 80}ms` }}
              >
                <div className="highlight-card-top">
                  <div className="highlight-icon">
                    <Icon size={28} strokeWidth={1.9} />
                  </div>
                  <span>{item.label}</span>
                </div>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
